import { IsNever, SchemaTypeName } from '../../../primitives';
import { ISchemaInput, ISIDefault, NestedSchema, RootSchema } from '../../../union';
import { ISchemaTuple } from './tuple.types';
import { TupleInput } from './TupleInput';

export * from './tuple.types';

/**
 * Property value is a tuple
 * - Can't yet support `enum`: typing is at least difficult, perhaps impossible
 */
export function tuple<ItemTypes extends TupleInput>(
    schema: RootSchema<ISchemaInput<ISchemaTuple<ItemTypes>, ISIDefault<ISchemaTuple<ItemTypes>>>>
): RootSchema<ISchemaTuple<ItemTypes>>;
export function tuple<ItemTypes extends TupleInput>(
    schema: NestedSchema<ISchemaInput<ISchemaTuple<ItemTypes>, ISIDefault<ISchemaTuple<ItemTypes>>>>
): NestedSchema<ISchemaTuple<ItemTypes>>;
export function tuple<ItemTypes extends TupleInput>(
    schema: ISchemaInput<ISchemaTuple<ItemTypes>, ISIDefault<ISchemaTuple<ItemTypes>>>
): ISchemaTuple<ItemTypes> {
    const { prefixItems } = schema;

    return {
        type: SchemaTypeName.array,
        minItems: prefixItems.length,
        maxItems: prefixItems.length,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = tuple({ description: '', prefixItems: [] as any, $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = tuple({ description: '', prefixItems: [] as any }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
